module.exports = __webpack_public_path__ + "img/paymee.1b5d2410.png";